import { IAppState } from '../../../AppModulesWrapper';

import { EAccountType } from '../../types/reducers/user';

export const selectBillingUserType = (state: IAppState): EAccountType | null => {
  return state.servicePickerWidget.user.billingInfo?.accountType || null;
};
